import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import React from 'react';
import CoreBadge from '@wix/da-ds/pkg/Badges/CoreBadge';
import BiSpan from '@wix/da-bi/pkg/Components/BiSpan';
import noop from '../../../utils/noop';
import { BiData } from '@wix/da-bi/pkg/events';
const UserCoreBadge = ({ corePackage, size, biData, className, openUserSymbolPopup = false, pushUserSymbolsPopup = noop })=>{
    if (openUserSymbolPopup) {
        const biEventData = BiData(_object_spread_props(_object_spread({}, biData), {
            symbol: corePackage !== null && corePackage !== void 0 ? corePackage : '',
            evid: 111
        }));
        const spanProps = {
            className
        };
        const onClick = (ev)=>{
            ev.preventDefault();
            // Only open the popup if we're not in an iframe
            if (window.self === window.top) {
                pushUserSymbolsPopup();
            }
        };
        return /*#__PURE__*/ React.createElement(BiSpan, _object_spread_props(_object_spread({}, spanProps), {
            // Role = "img" here to allow aria-label to exist on
            // this element without lighthouse throwing a fit
            role: "img",
            biData: biEventData,
            onClick: onClick,
            stopPropagation: true
        }), /*#__PURE__*/ React.createElement(CoreBadge, {
            corePackage: corePackage,
            size: size,
            className: className
        }));
    }
    return /*#__PURE__*/ React.createElement(CoreBadge, {
        corePackage: corePackage,
        size: size,
        className: className
    });
};
UserCoreBadge.displayName = 'UserCoreBadge';
export default UserCoreBadge;

//# sourceMappingURL=UserCoreBadge.js.map